import { gql } from '@/utilities/gql';

import type { FragmentOf } from '@/utilities/gql';

export const NARRATIVE_CARD_COMPACT_SYNTHETIC_OPTION_FRAGMENT = gql(`
  fragment NarrativeCardCompactSyntheticOptionFields on ValuationOption @_unmask {
    type
    fairValue
    intrinsicDiscount
    narrative {
      id
      isPrimary
      owner {
        displayName
      }
      company {
        id
        analysisValue {
          priceTargetAnalystCount
        }
        data {
          currencyInfo
        }
      }
    }
  }
`);

export type ValuationOption = FragmentOf<
  typeof NARRATIVE_CARD_COMPACT_SYNTHETIC_OPTION_FRAGMENT
>;
